import { BindingError } from "../BindingError.js";
import { FieldMarker } from "./FieldMarker.js";
import { HasManyRelationMarker } from "./HasManyRelationMarker.js";
import { HasOneRelationMarker } from "./HasOneRelationMarker.js";
import { assertNever } from "../utils/assertNever.js";
class EntityFieldMarkersContainer {
  constructor(hasAtLeastOneBearingField, markers, placeholders) {
    this.hasAtLeastOneBearingField = hasAtLeastOneBearingField;
    this.markers = markers;
    this.placeholders = placeholders;
  }
  getFieldByPlaceholder(placeholder) {
    const marker = this.markers.get(placeholder);
    if (marker instanceof FieldMarker) {
      return marker.fieldName;
    }
    if (marker instanceof HasOneRelationMarker || marker instanceof HasManyRelationMarker) {
      return marker.parameters.field;
    }
    if (marker === void 0) {
      throw new BindingError();
    }
    return assertNever();
  }
  *getPlaceholdersByField(field) {
    const placeholders = this.placeholders.get(field);
    if (placeholders === void 0) {
      return;
    }
    if (typeof placeholders === "string") {
      yield placeholders;
      return;
    }
    yield* placeholders.values();
  }
}
export {
  EntityFieldMarkersContainer
};
//# sourceMappingURL=EntityFieldMarkersContainer.js.map
